<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <div>
           
          <b-button variant="danger" @click="back">
            <i class="fa fa-chevron-left"></i>
            Back
          </b-button>
        </div><br/>
        <b-card header="Update Maximum Dwell Time" class="mt-1">
          <b-alert :show="isShowAlert" variant="success" isShowAlert="false">
            <p>
              Successfully Updated
              <b-button variant="primary" size="sm" @click="reload">
                <i class="fa fa-plus-circle"></i>&nbsp;Dwell Time
              </b-button>
            </p>
          </b-alert>

          <b-form-group id="dwelltime" label="Dwell Time">
            <input
              type="Text"
              class="form-control bg-white"
              v-model.trim="form.maxdwelltime"
              placeholder="Encode in minutes (60)"
            />
          </b-form-group>
          <b-form-group id="exampleGroup4">
            <b-form-checkbox-group
              stacked
              id="basicCustomCheckboxes"
              class="form-group col-md-12"
            >
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="isactive"
                  value="1"
                  v-model="checked"
                />
                <label class="custom-control-label" for="isactive"
                  >is Active</label
                >
              </div>
            </b-form-checkbox-group>
          </b-form-group>
          <div class="dispatch-table pull-right">
            <b-button type="submit" variant="primary" @click="onSubmit(2)">
              <i class="fa fa-save"></i>
              Update
            </b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import axios from "axios";
import miniToastr from "mini-toastr";
export default {
  data: function () {
    return {
      isShowAlert: false,
      form: {
        id: this.$route.params.id == undefined ? "" : this.$route.params.id,
        branchcode: "",
        status: 1,
        createdby: "",
        modifiedby: "",
        modifieddate: "",
        maxdwelltime: this.$store.state.maxdwell,
      },
      dwelltime: "",
      checked: true,
    };
  },

  created() {
    this.GetDwellTime();
  },

  methods: {
    onSubmit(action) {
      var vm = this;
      // this.form.id =
      this.form.branchcode = this.$store.getters.selectedWarehouse;
      (this.form.modifiedby =
        this.$store.getters.user.firstname +
        " " +
        this.$store.getters.user.lastname),
        console.log(this.form);
      axios
        .post(
          this.$store.state.IFMSURLlocal + "SprocDwellTime?action=" + action,
          this.form
        )
        .then((resp) => {
          this.GetDwellTime();
          this.isShowAlert = true;
        })
        .catch(function (err) {
          miniToastr.error("Try Again!");
          //   api.httpMsg(this, err.status, err.data);
          this.$store.commit("setLoading", false);
        });
    },

    GetDwellTime() {
      var vm = this;
      axios
        .get(
          this.$store.state.IFMSURLlocal +
            "dwelltime?brancode=" +
            vm.$store.getters.selectedWarehouse
        )
        .then((resp) => {
          vm.dwelltime = resp.data;
        })
        .catch(() => {
          return [];
        });
    },

    reload: function () {
      this.$router.go(this.$router.currentRoute);
    },

     back: function () {
        this.$router.push("/Maintenance/637481313038913286");
      },
  },

  watch: {
    checked: function (val) {
      if (val == true) {
        this.form.status = 1;
      } else {
        this.form.status = 0;
      }
    },
  },
};
</script>